import styled from "@emotion/styled";

export const SelectedBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const EditButtonWrapper = styled.div``;

export const ActionButton = styled.button`
  border: none;
  background: none;
  color: #2f8de4;
  font-weight: 500;
  font-size: 14px;
  font-family: Poppins, sans-serif;
  i {
    margin-right: 2.5px;
    font-size: 16px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EditButton = styled.button`
  border: none;
  background: none;
  font-weight: 500;
  font-size: 14px;
  font-family: Poppins, sans-serif;
  color: #2f8de4;
  cursor: pointer;
  i {
    margin-right: 2.5px;
    font-size: 16px;
  }
`;
